// @ts-nocheck
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertToISO } from "../../../../../CommonFunction/IsoDateTime";
import { ClearSpecificForm } from "../../../../../Store/FormDataReducer/FormFieldFunctions";
import DocumentuploadSection from "../../../../Templets/DocumentuploadSection/DocumentuploadSection";
import Button from "../../../Button/Button";
import PortalFooter from "../../../Reactportal/PortalFooter";
import Reactportal from "../../../Reactportal/Reactportal";
import AddItems from "../AddItems/AddItems";
import AddMeterialDetails from "../InvoiceAndItemTable/AddMeterial";
import AddMeterialTable from "../InvoiceAndItemTable/InvoiceAndItemTable";
import "./AddInvoice.scss";
import { ErrorToast } from "../../../ToastComponent/RectHotToast";
import { useModalContext } from "../../../Reactportal/ModalContext";
import { useEventListener } from "usehooks-ts";
import { GetTodaysDateINdmy } from "../../../../../CommonFunction/GetTodaysDate";
import { FormInputSectionComponent } from "../../../FormInputSectionComponent/FormInputSectionComponent";
import { replaceUnderscore } from "../../../../../CommonFunction/common";
import { updateValueForm } from "../../../FormInputSectionComponent/formUtils";
import { getFormSectionsAndFields } from "../../../../../Utils/AllPagesQuriesAndMutations";
import { useLazyQuery } from "@apollo/client";
import { checkFormErrors } from "../../../../custom_hooks/useCheckFormError";

const AddInvoice = ({
  show,
  TypeOfPortal,
  config,
  SetMeterial,
  fielddata,
  setMyData,
  Data,
  index,
  Parent_Form_Key,
}) => {
  const [openModal, setOpenModal] = useState(show);
  const Form_Key = Parent_Form_Key === "Consignment_Note" ? "PTL_CN_Material" : "FTL_CN_Material";
  const [ShowItemsModal, setShowItemsModal] = useState(false);
  const [ShowEditItemsModal, setShowEditItemsModal] = useState(false);
  const [totalItemsDetails, setTotalItemsDetails] = useState(0);
  const [totalQuantityDetails, setTotalQuantityDetails] = useState(0);
  const [totalFreightAmount, setTotalFreightAmount] = useState(0);
  const [totalBoxesDetails, setTotalBoxesDetails] = useState(0);
  const { pushModal, popModal, getTopModal } = useModalContext();
  const [formErrors, setFormErrors] = useState({});
  const [FormData, setFormdata] = useState({});
  const [InputFields, setInputFields] = useState([]);
  const [EditIndex, setEditIndex] = useState("");
  const [editObj, setEditObj] = useState({});
  const dispatch = useDispatch();
  const formRef = useRef({});
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  // eslint-disable-next-line
  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: Form_Key,
      },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setInputFields(data?.formSectionAndFields);
      },
    }
  );

  useEffect(() => {
    getFormSectionAndFields();
  }, []);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    if (InputFields.length) {
      if (Data && JSON.stringify(Data) !== "{}") {
        updateValueForm(formRef, {
          ...Data,
        });
      } else {
        updateValueForm(formRef, { Invoice_Date: GetTodaysDateINdmy(), Eway_Bill_Date: GetTodaysDateINdmy() });
      }
    }
  }, [InputFields]);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const Closeformfunction1 = () => {
    SetMeterial(false);
    setOpenModal(false);
    ClearSpecificForm(dispatch, Form_Key);
    popModal(Form_Key);
  };

  useEffect(() => {
    if (FormData?.Eway_Bill_Date) {
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            ReferFieldForDate: FormData?.Eway_Bill_Date,
          },
        },
      });
    }
  }, [FormData?.Eway_Bill_Date]);

  const submit = () => {
    let obj = {
      ...FormData,
      ASN_No: FormData?.ASN_No ? String(FormData?.ASN_No) : "",
      Eway_Bill_Number: FormData?.Eway_Bill_Number ? String(FormData?.Eway_Bill_Number) : "",
      Invoice_Date: FormData?.Invoice_Date ? FormData?.Invoice_Date : "",
      Eway_Bill_Date: FormData?.Eway_Bill_Date ? FormData?.Eway_Bill_Date : "",
      Eway_Bill_Expiry_Date: FormData?.Eway_Bill_Expiry_Date ? FormData?.Eway_Bill_Expiry_Date : "",
      Invoice_Number: FormData?.Invoice_Number ? String(FormData?.Invoice_Number) : "",
      Invoice_Value: FormData?.Invoice_Value ? String(FormData?.Invoice_Value) : "",
      Invoice_Add: FormDataFromRedux[Form_Key]?.Files?.Invoice_Add
        ? FormDataFromRedux[Form_Key]?.Files?.Invoice_Add
        : "",
      Eway_Bill_Add: FormDataFromRedux[Form_Key]?.Files?.Eway_Bill_Add
        ? FormDataFromRedux[Form_Key]?.Files?.Eway_Bill_Add
        : "",
    };

    if (Data?._id) {
      obj._id = Data?._id;
    }
    setMyData(obj, index);

    Closeformfunction1();
  };

  return (
    <>
      {openModal ? (
        <Reactportal open={openModal} onClose={Closeformfunction1} TypeOfPortal={"Add Invoice"}>
          <div className="AddMaterialModal">
            <div className="horizontalcontainer">
              {InputFields &&
                InputFields?.map((e) => {
                  return (
                    <div key={e.id} className="">
                      <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                      <div className="horizantalSection insidecontainer">
                        <FormInputSectionComponent
                          inputfields={e.fields}
                          Type={e.name}
                          onhandleFormikChange={HanldeChangeonForm}
                          validation_Schema={e?.Valid_schema}
                          onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                          formkey={Form_Key}
                          TypeOfPortal={TypeOfPortal}
                          formRef={formRef}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>

          </div>
          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            Form_key={Form_Key}
            TypeOfPortal={TypeOfPortal}
            submitform={""}
            submitType={""}
            SaveAndClose={() => {
              Validate_handleSubmit(submit);
            }}
            handleformclose={() => {
              Closeformfunction1();
              setOpenModal(!openModal);
            }}
          />
        </Reactportal>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default AddInvoice;

// const AddMeterialSection = ({ show, TypeOfPortal, fielddata, SetMeterial, config, setMyData, Data, index }) => {
//   const [openModal, setOpenModal] = useState(show);
//   const [Items, setItems] = useState<any[]>(Data.Invoice_Material_Data ? Data.Invoice_Material_Data : []);
//   const [ShowItemsModal, setShowItemsModal] = useState(false);
//   const [ShowEditItemsModal, setShowEditItemsModal] = useState(false);
//   const [totalItemsDetails, setTotalItemsDetails] = useState(0);
//   const [totalQuantityDetails, setTotalQuantityDetails] = useState(0);
//   const [totalFreightAmount, setTotalFreightAmount] = useState(0);
//   const [totalBoxesDetails, setTotalBoxesDetails] = useState(0);
//   const { pushModal, popModal, getTopModal } = useModalContext();
//   const [formErrors, setFormErrors] = useState({});
//   const [FormData, setFormdata] = useState({});
//   const Form_Key = "Add_Material";
//   const [EditIndex, setEditIndex] = useState("");
//   const [editObj, setEditObj] = useState({});
//   const dispatch = useDispatch();
//   const formRef = useRef({});
//   const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
//   // eslint-disable-next-line
//   console.log(Data);

//   useEffect(() => {
//     if (openModal) {
//       pushModal(Form_Key);
//     }
//   }, [openModal, Form_Key, pushModal]);

//   useEffect(() => {
//     const input = document.getElementsByName("Invoice_Date");
//     if (input.length > 0) {
//       input[input.length - 1].focus();
//     }
//   }, []);

//   useEffect(() => {
//     if (Data && JSON.stringify(Data) !== "{}") {
//       updateValueForm(formRef, {
//         ...fielddata,
//       });
//     } else {
//       console.log("Datata");
//       updateValueForm(formRef, { Invoice_Date: GetTodaysDateINdmy(), Eway_Bill_Date: GetTodaysDateINdmy() });
//     }
//   }, []);

//   const handleErrorsChange = (newErrors) => {
//     setFormErrors((currentErrors) => ({
//       ...currentErrors,
//       ...newErrors,
//     }));
//   };

//   const HanldeChangeonForm = (values) => {
//     setFormdata((prev) => ({
//       ...prev,
//       ...values,
//     }));
//   };

//   useEffect(() => {
//     console.log(FormData);
//   }, [FormData]);

//   const Closeformfunction1 = () => {
//     SetMeterial(false);
//     setOpenModal(false);
//     ClearSpecificForm(dispatch, Form_Key);
//     popModal(Form_Key);
//   };

//   const handleEditItems = (i) => {
//     setEditObj(Items[i]);
//     setEditIndex(i);
//     setShowEditItemsModal(true);
//   };

//   const handleDeleteItems = (index) => {
//     const newMaterial = [...Items];
//     newMaterial.splice(index, 1);
//     setItems(newMaterial);
//   };

//   // useEffect(() => {
//   //   const input = document.getElementsByName("Invoice_Date");
//   //   if (input.length > 0) {
//   //     input[0].focus();
//   //   }
//   // }, []);

//   useEffect(() => {
//     let totalChargeWeight = 0;
//     let totalQuantity = 0;
//     let totalBoxes = 0;
//     let totalFreightAmount = 0;
//     Items.forEach((e) => {
//       totalChargeWeight += Number(e.Charge_Weight);
//       totalQuantity += Number(e.Total_Quantity);
//       totalBoxes += Number(e.No_Of_Boxes);
//       totalFreightAmount += Number(e.Freight_Amount);
//     });
//     setTotalItemsDetails(totalChargeWeight);
//     setTotalQuantityDetails(totalQuantity);
//     setTotalBoxesDetails(totalBoxes);
//     setTotalFreightAmount(totalFreightAmount);
//   }, [Items]);

//   const handleAddItems = () => {
//     setShowItemsModal(true);
//   };

//   const replaceObjectAtIndex = (newObj, idx) => {
//     const newArr = Items.map((item, index) => {
//       if (index === idx) {
//         return newObj;
//       }
//       return item;
//     });
//     setItems(newArr);
//   };

//   // Function to handle keyboard events
//   const handleKeyDown = (event) => {
//     if (getTopModal() === Form_Key) {
//       if (event.key === "Escape") {
//         Closeformfunction1();
//       } else if (event.key === "F4") {
//         submit();
//       }
//     }
//   };

//   // Use the useEventListener hook from usehooks-ts to listen for keydown events
//   useEventListener("keydown", handleKeyDown);

//   const submit = () => {
//     console.log("submittt");
//     if (Items.length !== 0) {
//       if (String(index)) {
//         setMyData(
//           {
//             ...FormData,
//             ASN_No: FormData?.ASN_No ? String(FormData?.ASN_No) : "",
//             Eway_Bill_Number: FormData?.Eway_Bill_Number ? String(FormData?.Eway_Bill_Number) : "",
//             Invoice_Date: FormData?.Invoice_Date ? convertToISO(FormData?.Invoice_Date) : "",
//             Eway_Bill_Date: FormData?.Eway_Bill_Date ? convertToISO(FormData?.Eway_Bill_Date) : "",
//             Eway_Bill_Expiry_Date: FormData?.Eway_Bill_Expiry_Date ? convertToISO(FormData?.Eway_Bill_Expiry_Date) : "",
//             Invoice_Number: FormData?.Invoice_Number ? String(FormData?.Invoice_Number) : "",
//             Invoice_Value: FormData?.Invoice_Value ? String(FormData?.Invoice_Value) : "",
//             Invoice_Add: FormDataFromRedux[Form_Key]?.Files?.Invoice_Add
//               ? FormDataFromRedux[Form_Key]?.Files?.Invoice_Add
//               : "",
//             Eway_Bill_Add: FormDataFromRedux[Form_Key]?.Files?.Eway_Bill_Add
//               ? FormDataFromRedux[Form_Key]?.Files?.Eway_Bill_Add
//               : "",
//             Total_Item_Wgt: totalItemsDetails,
//             Total_Quantity: totalQuantityDetails ? totalQuantityDetails : 0,
//             Total_Boxes: totalBoxesDetails,
//             Total_Freight_Amount: totalFreightAmount,
//             _id: Data?._id ? Data?._id : "",
//           },
//           Items,
//           index
//         );
//       } else {
//         setMyData(
//           {
//             ...FormData,
//             ASN_No: FormData?.ASN_No ? String(FormData?.ASN_No) : "",
//             Eway_Bill_Number: FormData?.Eway_Bill_Number ? String(FormData?.Eway_Bill_Number) : "",
//             Invoice_Date: FormData?.Invoice_Date ? convertToISO(FormData?.Invoice_Date) : "",
//             Eway_Bill_Date: FormData?.Eway_Bill_Date ? convertToISO(FormData?.Eway_Bill_Date) : "",
//             Eway_Bill_Expiry_Date: FormData?.Eway_Bill_Expiry_Date ? convertToISO(FormData?.Eway_Bill_Expiry_Date) : "",
//             Invoice_Number: FormData?.Invoice_Number ? String(FormData?.Invoice_Number) : "",
//             Invoice_Value: FormData?.Invoice_Value ? String(FormData?.Invoice_Value) : "",
//             Invoice_Add: FormDataFromRedux[Form_Key]?.Files?.Invoice_Add
//               ? FormDataFromRedux[Form_Key]?.Files.Invoice_Add
//               : "",
//             Eway_Bill_Add: FormDataFromRedux[Form_Key]?.Files?.Eway_Bill_Add
//               ? FormDataFromRedux[Form_Key]?.Files?.Eway_Bill_Add
//               : "",
//             Total_Item_Wgt: totalItemsDetails,
//             Total_Quantity: totalQuantityDetails,
//             Total_Boxes: totalBoxesDetails,
//             Total_Freight_Amount: totalFreightAmount,
//             _id: Data?._id ? Data?._id : "",
//           },
//           Items
//         );
//       }
//       Closeformfunction1();
//     } else {
//       ErrorToast("Please add at least one item");
//     }
//   };

//   return (
//     <>
//       {openModal ? (
//         <Reactportal open={openModal} onClose={Closeformfunction1} TypeOfPortal={"Add Material"}>
//           <div className="AddMaterialModal">
//             {/* <div className="AddFieldsData AddMaterialField">
//               {config?.AddMaterial.map((e, i) => {
//                 return (
//                   <div key={e.id}>
//                     <AddMeterialDetails
//                       inputfields={e.fields}
//                       Type={e.name}
//                       handleErrorsChange={() => {}}
//                       fielddata={allFieldsData}
//                       TypeOfPortal={TypeOfPortal}
//                       Form_Key={Form_Key}
//                     />
//                   </div>
//                 );
//               })}
//             </div> */}
//             <div className="horizontalcontainer">
//               {config?.AddMaterial &&
//                 config?.AddMaterial.map((e) => {
//                   return (
//                     <div key={e.id} className="">
//                       <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
//                       <div className="horizantalSection insidecontainer">
//                         <FormInputSectionComponent
//                           inputfields={e.fields}
//                           Type={e.name}
//                           onhandleFormikChange={HanldeChangeonForm}
//                           validation_Schema={e?.Valid_schema}
//                           onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
//                           formkey={Form_Key}
//                           formRef={formRef}
//                         />
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//             <div className="Items">
//               <AddMeterialTable
//                 data={Items}
//                 handleDeleteMaterial={(i) => handleDeleteItems(i)}
//                 handleEditMaterial={(i) => handleEditItems(i)}
//               />
//             </div>
//             <div className="AddItemDiv">
//               <Button action={handleAddItems} text="Add Items" name="AddItems" type={""} children={""} disabled={""} />
//             </div>
//             {/* <div className="ItemDocuments">
//               <DocumentuploadSection
//                 data={config?.AddMeterialDocsUpload}
//                 TypeOfPortal={TypeOfPortal}
//                 LoadForm={true}
//                 formkey={Form_Key}
//                 values={FormData}
//                 formReference={formRef}
//               />
//             </div> */}
//           </div>
//           <PortalFooter
//             renderContent={() => <></>}
//             disabled={false}
//             submitform={submit}
//             submitType={""}
//             SaveAndClose={() => {
//               submit();
//             }}
//             handleformclose={() => {
//               Closeformfunction1();
//               setOpenModal(!openModal);
//             }}
//           />
//         </Reactportal>
//       ) : (
//         <div></div>
//       )}
//       {ShowItemsModal ? (
//         <AddItems
//           show={ShowItemsModal}
//           editData={undefined}
//           index={""}
//           itemConfig={{ AddMeterialItems: config?.AddMeterialItems }}
//           setItems={(val: any) => setItems((prev: any) => [...prev, val])}
//           setShowModal={() => setShowItemsModal(false)}
//         />
//       ) : null}
//       {ShowEditItemsModal ? (
//         <AddItems
//           show={ShowEditItemsModal}
//           editData={editObj}
//           itemConfig={{ AddMeterialItems: config?.AddMeterialItems }}
//           index={EditIndex}
//           setItems={(val: any, i: any) => replaceObjectAtIndex(val, i)}
//           setShowModal={() => setShowEditItemsModal(false)}
//         />
//       ) : null}
//     </>
//   );
// };
